import { clsx } from 'clsx'
import { CircleButton } from 'component/Button/CircleButton'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'
import { OfferItem } from 'type/rec'
import css from './Card2.module.scss'

type Props = {
  carousel: CarouselStore<OfferItem>
  item: OfferItem
}

export const Card2 = observer((props: Props) => {
  const { rec } = store
  const { carousel, item } = props
  const image = item.item_combo_image
  const selected = item === rec.item

  const onClick = useLatestCallback(() => {
    carousel.item = item
  })

  const onSelect = useLatestCallback(() => {
    rec.item = item
  })

  const onClose = useLatestCallback(() => {
    controller.closeFullscreen()
  })

  return <Space className={css.root} top onClick={onClick}>
    <div className={css.card}>
      {image && <Img src={image} />}
      <Vertical pin={[null, 8, 8, null]}>
        <Space className={clsx(css.bage, selected && css.selected)} center onClick={onSelect}>
          <Typo size={11} bold upper>
            {selected ? i18n('Selected') : i18n('SelectRec')}
          </Typo>
        </Space>
      </Vertical>
      <Vertical pin={[8, 8, null, null]}>
        <CircleButton size={40} action={onClose}>
          <Icon size={20} name="close" />
        </CircleButton>
      </Vertical>
    </div>
  </Space>
})
